import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

// Shared across every new animated component added in this pass (accordion,
// tabs indicator, carousels, sheet, ripple) so "prefers reduced motion" is
// checked once per component, consistently, rather than each one rolling its
// own AccessibilityInfo call.
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    let mounted = true;
    void AccessibilityInfo.isReduceMotionEnabled().then((value) => {
      if (mounted) setReduced(value);
    });
    const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', (value) => {
      if (mounted) setReduced(value);
    });
    return () => {
      mounted = false;
      subscription.remove();
    };
  }, []);

  return reduced;
}
